import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";

const TITLES = { privacy: "Informativa sulla Privacy", terms: "Termini e Condizioni", dpa: "Accordo sul Trattamento dei Dati (DPA)" };

export default function LegalPage({ docType }) {
  const [doc, setDoc] = useState(undefined);
  useEffect(() => {
    api.get(`/public/legal/${docType}`).then((r) => setDoc(r.data && r.data.id ? r.data : null)).catch(() => setDoc(null));
  }, [docType]);

  return (
    <div className="min-h-screen bg-[#FAF8F5] py-10 px-4" data-testid={`legal-page-${docType}`}>
      <div className="max-w-3xl mx-auto">
        <Link to="/login" className="text-sm text-[#8C532B] font-semibold" data-testid="legal-back">← Equiro</Link>
        <h1 className="font-display text-3xl font-bold text-[#1B3B2B] mt-4">{doc?.title || TITLES[docType] || "Documento legale"}</h1>
        {doc && (
          <p className="text-xs text-[#5F6B64] mt-1" data-testid="legal-meta">
            Versione {doc.version} · in vigore dal {doc.effective_date || "—"}
          </p>
        )}
        <div className="mt-6 bg-white border border-[#E5DEC9] rounded-xl p-6">
          {doc === undefined ? (
            <p className="text-[#5F6B64]">Caricamento…</p>
          ) : doc === null ? (
            <p className="text-[#5F6B64]" data-testid="legal-empty">Questo documento è in preparazione e sarà pubblicato a breve.</p>
          ) : (
            <div className="whitespace-pre-wrap text-sm text-[#2D3832] leading-relaxed" data-testid="legal-body">{doc.body}</div>
          )}
        </div>
        <div className="mt-6 flex gap-4 text-sm">
          <Link to="/privacy" className="text-[#8C532B]">Privacy</Link>
          <Link to="/termini" className="text-[#8C532B]">Termini</Link>
        </div>
      </div>
    </div>
  );
}
